define('pages/claim/ConditionCode/ConditionCodeComponent',[
	'core/can',
	'models/ConditionCode',
	'template!pages/claim/ConditionCode/ConditionCodeView.stache',
	'typeahead'
], function (can, ConditionCode, template) {
	function setTypeahead() {
		$('#ConditionCodes .typeahead').typeahead({
			highlight: true,
			hint: false,
			minLength: 0,
		}, {
			displayKey: 'code',
			source: ConditionCode.searchForCode,
			templates: {
				suggestion: function (data) {
					return '<p><strong>' + data.code + '</strong></p>';
				}
			}
		});

		//Cause typeahead's version is old, we have to use this way to show the dropdown when focus
		//This can't move to component's events 
		$('#ConditionCodes .typeahead').on('focus', function () {
			var val = $(this).typeahead('val');
			$(this).typeahead('val', 'false').typeahead('val', val);
		});
	}

	function makeConditionCodeList(codes, fls, visible) {
		// Create List
		var listForDisplay = new ConditionCode.List;
		for (var i = 0; i < fls.length; i++) {
			var code = codes.attr(i),
				exists = (code !== undefined);
			listForDisplay.push({
				Code: codes.attr(i),
				FieldLocator: fls[i],
				isHidden: !exists && (i > visible - 1)
			});
		}

		// Bind to Claim
		listForDisplay.bind('change', function () {
			var listForModel = [];
			this.each(function (code) {
				if (code.attr('Code')) {
					listForModel.push(code.attr('Code'));
				}
			});
			codes.replace(listForModel);
		});

		return listForDisplay;
	}

	return can.Component.extend({

		tag: 'claim-conditioncodes',

		template: can.view(template),

		scope: function (attrs, scope, el) {
			return {
				isOpen: false,
				ConditionCodes: makeConditionCodeList(
					attrs.claim.attr('ConditionCodes'),
					[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
					attrs.visible
				)
			}
		},

		events: {

			'.codes-open click': function (el, ev) {
				this.scope.attr('isOpen', true);
				setTypeahead();
			},

			'.codes-more click': function (el, ev) {
				this.scope.attr('ConditionCodes').each(function (code) {
					code.attr('isHidden', false);
				});
				setTypeahead();
			},

			'.codes-collapse click': function (el, ev) {
				var $codes = el.closest('#ConditionCodes'),
					codes = this.scope.attr('ConditionCodes');
				for (var i = codes.attr('length') - 1; i >= 0; --i) {
					var code = codes.attr(i);
					if (!code.attr('Code')) {
						if (i === 0) {
							this.scope.attr('isOpen', false);
						} else {
							code.attr('isHidden', true);
						}
					} else {
						break;
					}
				}
			},

			'.typeahead typeahead:selected': function (el, ev, suggestion) {
				$(ev.target).trigger('change');
			},

		}

	});
});
